import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import propTypes from 'prop-types';
import jwtDecode from 'jwt-decode';
import TextField from '../text-field/text-field';
import mergeI18n from '../../lib/util/merge-i18n';
import tokenIsValid from '../../lib/util/token-is-valid';
import i18n from './i18n';
import validateLogIn from './validator';
import { lssLogin, getRequest } from '../../services/request-processor';
import { handleBlur, handleInputChange, getFormError } from '../../lib/form';
import {
	ACCOUNT_ROUTE, CONDITION_ROUTE, CONTACT_COMPANY_ROUTE,
	EXISTING_APPOINTMENT_ROUTE, GET_ASSISTANCE_ROUTE, REQUEST_STATUS
} from '../../constants/constants';

class LogIn extends React.Component {
	constructor (props) {
		super(props);
		this.state = {
			vin: '',
			accountNo: '',
			error: null,
			formErrors: [],
			blurredFields: [],
			isFetchingData: false
		};

		this.handleInputChange = handleInputChange.bind(this);
		this.handleBlur = handleBlur.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.loadRequestData = this.loadRequestData.bind(this);
	}

	componentDidMount () {
		this.props.setParentState({
			progressIndex: -1,
			canLogOut: false,
			canGoToHomePage: true
		});
	}

	handleSubmit (event) {
		event.preventDefault();
		this.setState({ isFetchingData: true });
		lssLogin(this.state.vin, this.state.accountNo, (err, res) => {
			const token = _.get(res, 'body.result');

			if (err || !token || !tokenIsValid(token)) {
				this.setState({ error: err && err.status ? err.status : 0 });
				this.setState({ isFetchingData: false });
				this.props.setParentState({
					isAuthenticated: false
				});
			} else {
				const decoded = jwtDecode(token);
				this.props.setParentState({
					isAuthenticated: true
				});
				window.sessionStorage.setItem('token', token);
				window.sessionStorage.setItem('tokenClaims', JSON.stringify(decoded));

				this.loadRequestData(token, decoded);
			}
		});
	}

	loadRequestData (token, tokenClaims) {
		const parent = this;

		getRequest(tokenClaims.requestId, token, function (err, res) {
			const inspectionRequest = _.get(res, 'body.result');
			parent.setState({ isFetchingData: false });

			if (err && err.status && err.status === 404) {
				parent.setState({ error: 401 });
			} else if (err) {
				parent.setState({ error: 500 });
			} else if (!inspectionRequest) {
				parent.setState({ error: 401 });
			} else if (!inspectionRequest.status || !_.isInteger(inspectionRequest.status)) {
				parent.setState({ error: 500 });
			} else {
				parent.props.setParentState({ inspectionRequest });

				if (inspectionRequest.activeAppointments.length) {
					parent.props.setRoute(EXISTING_APPOINTMENT_ROUTE);
				} else if (inspectionRequest.status === REQUEST_STATUS.COMPLETE) {
					parent.props.setRoute(CONDITION_ROUTE);
				} else if (inspectionRequest.customer === 'CHRYSLER SANTANDER') {
					const minDate = moment().add(inspectionRequest.lssSchedRestrictMin, 'days');
					const maxDate = moment().add(inspectionRequest.lssSchedRestrictMax, 'days');

					if (!inspectionRequest.maturityDate || !moment(inspectionRequest.maturityDate).isBetween(minDate, maxDate)) {
						parent.props.setRoute(CONTACT_COMPANY_ROUTE);
					} else {
						parent.props.setRoute(ACCOUNT_ROUTE);
					}
				} else {
					parent.props.setRoute(ACCOUNT_ROUTE);
				}
			}
		});
	}

	render () {
		const __ = mergeI18n(this.props.language, i18n);

		let errorMessage = null;
		switch (this.state.error) {
			case 401:
				errorMessage = __.unauthorized;
				break;
			case 404:
				errorMessage = __.ssoFailed;
				break;
			case 500:
				errorMessage = __.error;
				break;
			default:
				break;
		}

		const handleFormError = getFormError(this.state.blurredFields, this.state.formErrors, __.validation);
		document.title = `${__.titleStem} - ${__.pageTitle}`;

		return (
			<div id='lss-content'>
				<div id='log-in' className='row'>
					<div className='col-sm-12 col-md-6 col-md-offset-3'>
						<form onSubmit={this.handleSubmit} className='col-xs-12 col-sm-6 col-md-8 text-center center-block'>
							<h1>{__.welcomeMessage}</h1>
							<h2>{__.enterAccountInfo}</h2>
							<div className='row'>
								<div className='col-md-8 col-md-offset-2'>
									<TextField
										placeholder='VIN'
										name='vin'
										value={this.state.vin}
										onChange={this.handleInputChange}
										onBlur={(e) => this.handleBlur(e, validateLogIn)}
										formError={handleFormError('vin')}
									/>
									<TextField
										placeholder={__.accountNo}
										name='accountNo'
										value={this.state.accountNo}
										onChange={this.handleInputChange}
										onBlur={(e) => this.handleBlur(e, validateLogIn)}
										formError={handleFormError('accountNo')}
									/>
									{errorMessage !== null &&
										<p className='error-message'>{errorMessage}</p>}
									<button id='submit-form' className='btn btn-primary' type='submit'>{__.submitButton}</button>
									<button
										className='btn btn-link'
										type='button'
										disabled={this.state.formErrors.length > 0 || this.state.isFetchingData}
										onClick={() => this.props.setRoute(GET_ASSISTANCE_ROUTE)}
									>
										{__.needHelp}
									</button>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		);
	}
}

LogIn.propTypes = {
	language: propTypes.string.isRequired,
	setParentState: propTypes.func.isRequired,
	setRoute: propTypes.func.isRequired
};
export default LogIn;
